import React, {useContext} from "react";
import AuthorizationContext from "../../../_helper/Authorization";
import {AuthorizationContextType} from "../../../_helper/Authorization/AuthorizationTypes";
import {MultimediaService} from "../../SystemCore/Multimedia";
import {Image} from '../../../AbstractElements';

interface profileImageProps {
    profileImageUrl: string;
    setUrl: (url: string) => void;
    callBack?: (data: { multimedia_id: number; multimedia: any }) => void;
    params?: {
        link_type_key: string,
        link_type_id: number | undefined,
        single?: boolean,
        role?: string,
    };
}

const ProfileImage = ({profileImageUrl, setUrl, callBack, params}: profileImageProps) => {
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;

    const {errorHandler} = authContext || {};
    const onSubmit = async ({file}: { file: File }) => {
        try {
            const response = await MultimediaService.uploadMultimedia(file, params);
            if (response?.id) {
                callBack && callBack({
                    multimedia_id: response.id,
                    multimedia: response,
                });
            }
        } catch (exception: any) {
            errorHandler(exception);
        }
    };
    const readUrl = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files || event.target.files.length === 0) return;
        const mimeType = event.target.files[0].type;

        if (mimeType.match(/image\/*/) == null) {
            return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
            const readerResult = typeof reader.result === 'string' ? reader.result : '';
            setUrl(readerResult);
        };
        onSubmit({file: event.target.files[0]});
    };

    return <div className='user-image'>
        <div className='avatar'>
            <Image attrImage={{
                className: 'step1',
                alt: 'logo',
                src: profileImageUrl
            }}/>
        </div>
        <div className='icon-wrapper step2' data-intro='Change Profile image here'>
            <i className='icofont icofont-pencil-alt-5'>
                <input className='upload' type='file' accept='image/*' onChange={(e) => readUrl(e)}/>
            </i>
        </div>
    </div>

}
export default ProfileImage;